import { DayType } from '@/features/common/helpers/moment';
import { GlobalResponseType } from '@/features/common/types';
import {
  CarrierCodeType,
  PackageItem, PackageType, ShipFrom, ShipTo,
} from '@/features/shipment/types';

export enum PickupStatus {
  Scheduled = 'Scheduled',
  Cancelled = 'Cancelled'
}

export interface PickupPackageItemType extends PackageItem {
  carrierTrackingNumber: string,
  shipStatus: string,
}
export interface UnscheduledPickups {
  billingOption?: string,
  username: string,
  createdBy: string,
  carrierCode: string,
  selectedService: string,
  serviceName: string,
  packageType: keyof typeof PackageType,
  packages: PickupPackageItemType[],
  shipDateTime: string,
  trackingNumber: string,
  cutoffTime: string,
  fromAddress: ShipFrom,
  toAddress: ShipTo,
  deleted?: boolean,
  myAccount?: boolean,
  hasComments?: boolean,
  show?: boolean,
  onTime?: string,
  quotedPrice?: string,
  reference?: string,
  signatureOption: string,
}

export interface SchedulePickupRequest {
  trackingNumbers: string[],
  readyDateTime?: string | null,
  closedDateTime: string,
  location: string,
  comments?: string,
}

export interface SchedulePickupResponse extends GlobalResponseType {
  id?: number,
  pickupRequestNumber?: string,
  carrierPhone?: string,
  isExternalLink?: boolean,
}

export interface SelectedUnscheduledPickup extends UnscheduledPickups {
  index: number,
}

export interface ScheduleDataType {
  pickupDate: DayType | null,
  pickupLocation: string,
  comments?: string,
  earliestTime: string | null,
  latestTime: string
}

export interface ScheduledPickupItem {
  id: number
  carrierCode: keyof typeof CarrierCodeType,
  selectedService?: string,
  requestNumber: string,
  status: 'Scheduled' | 'Cancelled',
  pickupRequestDate: string,
  readyTime: string,
  closeTime: string,
  packageCount: number,
  pickupLocation: string,
  pickupComments: string,
  fromAddress: ShipFrom,
  carrierPhone?: string,
  isCancellable: boolean,
}

export interface CancelPickupResponse extends GlobalResponseType {
  errorType?: 'string',
}
